export default "__VITE_ASSET__CEppdfN1__"